import React, { useState } from 'react';
import Button from 'components/DesignSystem/Button';
import About from 'components/Meteorology/Agro/CultureIndex/Area/About';
import useMapsControl from 'hooks/Meteorology/Agro/CultureIndex/Area/useMapsControl';
import MapDisplay from 'components/Meteorology/Agro/CultureIndex/Area/MapDisplay';
import AreaMobile from 'components/Meteorology/Agro/CultureIndex/Area/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';
import { Col, Row } from 'react-bootstrap';

export default function Area() {
  const [showAbout, setShowAbout] = useState(false);
  const isMobile = useIsMobile();
  const {
    maps,
    addMapDisabled,
    addMap,
  } = useMapsControl();

  if (isMobile) {
    return <AreaMobile />;
  }

  return (
    <>
      <About show={showAbout} onHide={() => setShowAbout(false)} />
      <div className="d-flex justify-content-end">
        <Button
          id="culture-index-area-add-map"
          icon="add"
          onClick={addMap}
          disabled={addMapDisabled}
        >
          Adicionar mapa
        </Button>
        {/* <Button
          id="culture-index-area-about"
          className="ms-2"
          icon="info"
          onClick={() => setShowAbout(true)}
        /> */}
      </div>
      <Row className="mt-3 mb-5">
        {maps.map((areaMap, index) => (
          <Col key={areaMap.id}>
            <MapDisplay areaMap={areaMap} position={index + 1} totalMaps={maps.length} />
          </Col>
        ))}
      </Row>
    </>
  );
}
